import { render } from "./PatientNotifications.vue?vue&type=template&id=b824e4ae"
import script from "./PatientNotifications.vue?vue&type=script&lang=js"
export * from "./PatientNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__